import {DeepgramClient} from '@deepgram/sdk';
import { isAxiosError } from 'axios';
import aiClient from '@/shared/api/clients/aiClient';

const DEPGRAM_MODEL = "nova-3";

export const useLiveVoiceTranscription = () => {
    const getDeepgramAccessToken = async () => {
        let data: { access_token?: string };
        try {
          ({ data } = await aiClient.get('/transcriptionToken'));
        } catch (err) {
          const status = isAxiosError(err) ? err.response?.status : undefined;
          throw new Error(
            `Failed to fetch Deepgram transcription token${status ? ` (HTTP ${status})` : ''}`,
          );
        }
        if (!data?.access_token) {
          throw new Error('Transcription token response missing access_token');
        }
        return data.access_token;
    }

    const getDeepgramSocketConnection = async () => {
        const accessToken = await getDeepgramAccessToken();
        const deepgram = new DeepgramClient({ accessToken });
        const socket = await deepgram.listen.v1.connect({
            model: DEPGRAM_MODEL,
            encoding: "opus",
            punctuate: "true",
            interim_results: "true",
            Authorization: `Bearer ${accessToken}`
        });
        return socket;
    }

    return { getDeepgramSocketConnection };
};